var _excluded = ["type", "inputRef", "show", "width", "size", "autoFocus", "placeholder", "placement", "prefix", "prepend", "append", "onShow", "onHide", "onPressEnter", "onBlur", "onFocus", "filled", "invalid", "renderTrigger", "popoverWrapperClassName", "popoverZIndex"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useForceUpdate } from '@okee-uikit/react-hooks';
import { guid } from '@okee-uikit/react-utils';
import { useConfig, useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { useAutoComplete } from '../../hooks/autocomplete';
import { RcManualTrigger } from '../../hooks/popper';
import { SelectInputWrapper } from '../util/SelectInputWrapper';
import { RcPopover } from '../../units/popover-wrapper';
import { ClickTrigger } from '../popover/components/ClickTrigger';
import { AutoCompletePanel } from './AutoCompletePanel';
export function AutoCompleteMain(props) {
  var locale = useLocale('auto-complete.placeholder');

  var type = props.type,
      inputRef = props.inputRef,
      show = props.show,
      width = props.width,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      autoFocus = props.autoFocus,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? locale : _props$placeholder,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom-start' : _props$placement,
      prefix = props.prefix,
      prepend = props.prepend,
      append = props.append,
      onShow = props.onShow,
      onHide = props.onHide,
      onPressEnter = props.onPressEnter,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      filled = props.filled,
      invalid = props.invalid,
      renderTrigger = props.renderTrigger,
      popoverWrapperClassName = props.popoverWrapperClassName,
      popoverZIndex = props.popoverZIndex,
      extra = _objectWithoutProperties(props, _excluded);

  var _useConfig = useConfig(),
      componentSizeMap = _useConfig.componentSizeMap;

  var forceUpdate = useForceUpdate();
  var autoComplete = useAutoComplete();
  var keyword = autoComplete.keyword,
      multiple = autoComplete.multiple,
      selectedValue = autoComplete.selectedValue,
      allowClear = autoComplete.allowClear,
      disabled = autoComplete.disabled;
  var refPopoverId = useMemo(function () {
    return guid();
  }, []);
  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  var triggerCls = usePrefixCls('auto-complete-main-trigger');
  useEffect(function () {
    autoComplete.addListener('update', forceUpdate);
    return function () {
      return autoComplete.removeListener('update', forceUpdate);
    };
  }, []);
  var handleReset = useCallback(function () {
    autoComplete.reset();
  }, []);
  var handleClear = useCallback(function () {
    autoComplete.onClear();
  }, []);
  var handleSelect = useCallback(function (item) {
    autoComplete.handleSelect(item);
  }, []);
  var onKeywordChange = useCallback(function (e) {
    autoComplete.onKeywordChange(e.target.value);
  }, []);
  var selectInputRef = useRef(null);
  var innerInputRef = useMemo(function () {
    return inputRef ? inputRef : selectInputRef;
  }, [inputRef]);
  var onPanelClick = useCallback(function () {
    var _a;

    multiple && ((_a = innerInputRef.current) === null || _a === void 0 ? void 0 : _a.focus());
  }, [multiple]);
  useEffect(function () {
    autoComplete.addListener('on-select', onPanelClick);
    return function () {
      autoComplete.removeListener('on-select', onPanelClick);
    };
  }, []);
  var panelDomRef = useRef(null);
  var selectInputWrapperRef = useRef(null);
  var onOutsideClick = useCallback(function (event) {
    var _a, _b, _c;

    if (!!renderTrigger) {
      if (event.target !== null && !((_a = event === null || event === void 0 ? void 0 : event.composedPath()) === null || _a === void 0 ? void 0 : _a.includes(innerInputRef.current))) {
        onHide === null || onHide === void 0 ? void 0 : onHide();
      }

      return;
    }

    if (event.target !== null && event.target !== innerInputRef.current && !((_b = panelDomRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target)) && !((_c = selectInputWrapperRef.current) === null || _c === void 0 ? void 0 : _c.contains(event.target))) {
      onHide && onHide();
    }
  }, []);
  useEffect(function () {
    window.addEventListener('click', onOutsideClick);
    return function () {
      window.removeEventListener('click', onOutsideClick);
    };
  }, []);
  var multipleClassName = usePrefixCls('select-input-wrapper', {
    focused: show
  });
  var getPopupContainer = useCallback(function () {
    return typeof window === 'undefined' ? null : document.body;
  }, []);
  var triggerRef = useRef(null);
  var computedRef = renderTrigger ? innerInputRef : triggerRef;
  var triggerHeight = useMemo(function () {
    if (computedRef && computedRef.current && computedRef.current.getBoundingClientRect) {
      var rect = computedRef.current.getBoundingClientRect();
      return rect.height;
    }

    return componentSizeMap[size].height;
  }, [show, computedRef]);
  return React.createElement(React.Fragment, null, renderTrigger ? React.createElement(ClickTrigger, {
    triggerId: triggerId,
    className: triggerCls,
    disabled: disabled,
    onClick: onFocus,
    ref: innerInputRef
  }, renderTrigger === null || renderTrigger === void 0 ? void 0 : renderTrigger(selectedValue, show, {
    hide: onHide,
    show: onFocus,
    reset: handleReset,
    clear: handleClear,
    instance: autoComplete,
    triggerRef: innerInputRef
  })) : React.createElement(RcManualTrigger, {
    triggerId: triggerId,
    className: triggerCls,
    disabled: disabled,
    show: show,
    ref: triggerRef
  }, React.createElement(SelectInputWrapper, {
    multiple: !!multiple,
    writeable: true,
    type: multiple ? undefined : type,
    ref: selectInputWrapperRef,
    inputRef: innerInputRef,
    popperInput: multiple ? show : false,
    show: autoFocus,
    size: size,
    width: width,
    keyword: keyword,
    datasource: selectedValue,
    disabled: disabled,
    clearable: allowClear,
    placeholder: placeholder,
    onClear: handleClear,
    onCloseItem: handleSelect,
    onChange: onKeywordChange,
    onPressEnter: onPressEnter,
    onFocus: onFocus,
    onBlur: onBlur,
    hotKeyHandlers: autoComplete,
    prepend: prepend,
    append: append,
    prefix: prefix,
    className: multiple ? multipleClassName : undefined,
    filled: filled,
    invalid: invalid
  })), React.createElement(RcPopover, {
    show: show,
    arrow: false,
    refType: "trigger",
    refId: triggerId,
    onShow: onShow,
    onHide: handleReset,
    placement: placement,
    preventOverflow: false,
    triggerIds: triggerIds,
    popoverId: refPopoverId,
    scaleAnimation: false,
    offset: {
      x: 0,
      y: 0 - triggerHeight
    },
    getPopper: function getPopper() {
      return React.createElement("div", {
        style: {
          height: triggerHeight
        }
      });
    }
  }), React.createElement(RcPopover, {
    show: show,
    arrow: false,
    refType: "popover",
    refId: refPopoverId,
    placement: placement,
    triggerIds: triggerIds,
    unionPopoverIds: [refPopoverId],
    scaleAnimation: "y",
    offset: {
      x: 0,
      y: 4
    },
    popoverClassName: popoverWrapperClassName,
    getPopper: React.createElement(AutoCompletePanel, _objectSpread(_objectSpread({
      domRef: panelDomRef,
      triggerId: triggerId
    }, extra), {}, {
      onClick: onPanelClick
    })),
    followTrigger: true,
    getPopupContainer: getPopupContainer,
    zIndex: popoverZIndex
  }));
}